import { render, staticRenderFns } from "./ListaCancelamento.vue?vue&type=template&id=656bfad8"
import script from "./ListaCancelamento.vue?vue&type=script&lang=js"
export * from "./ListaCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports